import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import cl from './ArticlesTeaser.module.css';
import B2BService from '../../API/B2BService';
import { IconBook, IconClock, IconEye, IconArrowRight } from '../../components/icons';
import useReveal from '../../hooks/useReveal';

// Тизер раздела «Статьи». Показываем 6 самых читаемых статей из раздела
// «Интеграция». Подтягиваются с b2b-микросервиса. Клик ведёт на внутреннюю
// страницу /articles/:id (а не во внешнюю админ-панель, как раньше).
export default function ArticlesTeaser() {
    const [top, setTop] = useState([]);

    useEffect(() => {
        B2BService.getArticles({ category: 'integration' }).then(list => {
            list.sort((a, b) => (b.views_count || 0) - (a.views_count || 0));
            setTop(list.slice(0, 6));
        });
    }, []);

    const revealRef = useReveal();
    return (
        <section className={cl.section} id="articles-teaser" ref={revealRef}>
            <div className={cl.inner}>
                <div className={cl.head}>
                    <div>
                        <span className={cl.eyebrow} data-reveal="down">
                            <IconBook width={14} height={14}/> Бесплатно · без регистрации
                        </span>
                        <h2 className={cl.title} data-reveal="up" style={{ '--reveal-delay': '100ms' }}>
                            Читайте <span className={cl.accent}>статьи по интеграции</span><br/>
                            прежде чем решиться
                        </h2>
                        <p className={cl.lead} data-reveal="up" style={{ '--reveal-delay': '180ms' }}>
                            Мы собрали практические разборы: <b>как открыть IT-направление,
                            какое оборудование закупить, какие преподаватели подойдут</b> и
                            сколько стоит запустить. Все статьи — открытые.
                        </p>
                    </div>
                    <Link to="/articles" className={cl.viewAll} data-reveal="right" style={{ '--reveal-delay': '260ms' }}>
                        Все статьи <IconArrowRight width={16} height={16}/>
                    </Link>
                </div>

                {top.length > 0 && (
                    <div className={cl.grid} data-reveal-stagger>
                        {top.map((a, i) => (
                            <Link key={a.id} to={`/articles/${a.id}`} className={cl.card}
                                data-reveal={i % 3 === 0 ? 'pop' : (i % 2 === 0 ? 'left' : 'right')}>
                                <div className={cl.cardMeta}>
                                    <span><IconClock width={12} height={12}/> {a.estimated_read_time} мин</span>
                                    <span><IconEye width={12} height={12}/> {a.views_count}</span>
                                </div>
                                <h3 className={cl.cardTitle}>{a.title}</h3>
                                <p className={cl.cardSummary}>{a.summary}</p>
                                <span className={cl.cardLink}>
                                    Читать <IconArrowRight width={12} height={12}/>
                                </span>
                            </Link>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
}
